import { Hourglass, RotateCw } from 'lucide-react';
import ErrorState from './ErrorState';
import { PRIMARY_BUTTON, SECONDARY_BUTTON, MICRO_LABEL } from '../constants';

const ServerBusy = ({ onRetry, onChooseAnother }) => (
    <ErrorState
        icon={Hourglass}
        title="Server busy"
        actions={
            <>
                <button type="button" onClick={onRetry} className={PRIMARY_BUTTON}>
                    <RotateCw className="w-3.5 h-3.5" />
                    <span className={MICRO_LABEL}>Try Again</span>
                </button>
                <button type="button" onClick={onChooseAnother} className={SECONDARY_BUTTON}>
                    <span className={MICRO_LABEL}>Choose Another Photo</span>
                </button>
            </>
        }
    >
        <p>The simulation service is busy. Please try again after 20&ndash;30 seconds.</p>
    </ErrorState>
);

export default ServerBusy;
